// One timeline for the pinned hero, shared by the 3D tube and the DOM scan frame so they never drift apart.
// Every value is a share (0 to 1) of the hero's pinned scroll.

export type Range = readonly [from: number, to: number]

// The half turn, shrink and settle.
export const TURN: Range = [0, 0.4]

// The scan frame fades in once the tube has settled on its back, sweeps down, then fades away.
export const FRAME_IN: Range = [0.42, 0.48]
export const SWEEP: Range = [0.46, 0.9]
export const FRAME_OUT: Range = [0.9, 0.96]

// Scan frame geometry, as shares of the settled tube's height (0 is the top of the crimp).
export const FRAME_HEIGHT = 0.26
export const FRAME_FROM = -0.05
export const FRAME_TO = 0.8

// Idle float and cursor tilt only live before the first bit of scrolling.
export const IDLE_FADE: Range = [0, 0.06]

export const clamp01 = (value: number): number => Math.min(Math.max(value, 0), 1)

export const segment = (value: number, [from, to]: Range): number => clamp01((value - from) / (to - from))

export const easeInOut = (t: number): number => 0.5 - 0.5 * Math.cos(Math.PI * clamp01(t))

export const turnAt = (progress: number): number => easeInOut(segment(progress, TURN))

export const frameTopAt = (progress: number): number => FRAME_FROM + (FRAME_TO - FRAME_FROM) * segment(progress, SWEEP)

export const frameOpacityAt = (progress: number): number => easeInOut(segment(progress, FRAME_IN)) * (1 - easeInOut(segment(progress, FRAME_OUT)))
